import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchCricketNews } from "../../services/api";
import CricketLive from "../../components/sports/CricketScore";

function Cricket() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchCricketNews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>Cricket News | Bharat Abroad Sports</title>
        <meta
          name="description"
          content="Latest cricket news, live updates, match previews, and player insights."
        />
      </Helmet>

      <SportsNavBar />

      <div
        style={{ background: "#f5f5f5", minHeight: "100vh", padding: "20px" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <NewsSection
            title="Cricket News"
            articles={articles}
            category="cricket"
          />

          {/* <CricketLive /> */}
        </div>
      </div>
    </>
  );
}

export default Cricket;
